import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  INBOX_FEATURE_KEY,
  State,
  InboxPartialState,
  messageAdapter
} from './inbox.reducer';

// Lookup the 'Inbox' feature state managed by NgRx
export const getInboxState = createFeatureSelector<InboxPartialState, State>(
  INBOX_FEATURE_KEY
);

const { selectAll, selectEntities } = messageAdapter.getSelectors();

export const getAllMessage = createSelector(getInboxState, (state: State) =>
  selectAll(state)
);

export const getMessages = createSelector(
  getInboxState,
  (state: State) => selectAll(state)
);

export const getMessageEntities = createSelector(
  getInboxState,
  (state: State) => selectEntities(state)
);

export const getMessageLoading = createSelector(
  getInboxState,
  (state: State) => state.loading
);

export const getImageUploading = createSelector(
  getInboxState,
  (state: State) => state.uploading
);

export const getFileError = createSelector(
  getInboxState,
  (state: State) => state.error
);

export const getFiles = createSelector(
  getInboxState,
  (state: State) => state.files || {}
);

export const getFileData = createSelector(
  getInboxState,
  (state: State) => state.fileData || {}
);

export const getFileItems = createSelector(
  getInboxState,
  (state: State) => state.fileItems
);

export const getSelectedId = createSelector(
  getInboxState,
  (state: State) => state.selectedId
);

export const getSelected = createSelector(
  getMessageEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);
